import { render, staticRenderFns } from "./AdminCargasComponent.vue?vue&type=template&id=73221776"
import script from "./AdminCargasComponent.vue?vue&type=script&lang=ts"
export * from "./AdminCargasComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports